<template>
  <div class="common-seach-wrap">
    <el-tabs v-model="activeName">
      <el-tab-pane label="技师入驻" name="examine"></el-tab-pane>
      <el-tab-pane label="技师评价" name="evaluate"></el-tab-pane>
      <el-tab-pane label="营业执照" name="business"></el-tab-pane>

      <el-tab-pane label="实名认证" name="realname"></el-tab-pane>
      <el-tab-pane label="资质认证" name="qualification"></el-tab-pane>
      <el-tab-pane label="无犯罪证明" name="nocrime"></el-tab-pane>
      <el-tab-pane label="签署协议" name="protocol"></el-tab-pane>
      <el-tab-pane label="健康证" name="healthy"></el-tab-pane>

    </el-tabs>
    <examine v-if="activeName == 'examine'"></examine>
    <evaluate v-if="activeName == 'evaluate'"></evaluate>
    <business v-if="activeName == 'business'"></business>
    <realname v-if="activeName == 'realname'"></realname>
    <qualification v-if="activeName == 'qualification'"></qualification>
    <nocrime v-if="activeName == 'nocrime'"></nocrime>
    <protocol v-if="activeName == 'protocol'"></protocol>
    <healthy v-if="activeName == 'healthy'"></healthy>

  </div>
</template>
<script>
import evaluate from "./evaluate/list";
import business from "./business/list";
import examine from "./examine/index";
import realname from "./realname/list";
import qualification from "./qualification/list";
import nocrime from "./nocrime/list";
import protocol from "./protocol/list";
import healthy from "./healthy/list";

export default {
  components: {
    evaluate,
    business,
    examine,
    realname,
    qualification,
    nocrime,
    protocol,
    healthy
  },
  data() {
    return {
      activeName: "examine"
    };
  },
  methods: {}
};
</script>

<style></style>



// WEBPACK FOOTER //
// src/views/technician/process/index.vue